import type {fancyOperations} from '@freckle/educator-entities/ts/openapi-clients'
import {fancyClient, extractData} from '@freckle/educator-entities/ts/openapi-clients'

export type SharedOrTransferredStudentT = Omit<
  fancyOperations['getStudentsSharesR']['responses'][200]['content']['application/json'][0],
  'createdAt'
>

export const fetchSharedOrTransferredStudents = (): Promise<Array<SharedOrTransferredStudentT>> =>
  fancyClient.GET('/2/student-shares').then(extractData)
